import React from 'react'
import { Button, Row, Col } from 'react-bootstrap'
import { FaUpload, FaBrain, FaPencilAlt, FaRocket } from 'react-icons/fa'
import { SectionTitle, DetailCard, DetailHeader, ActionsSection, ActionButton } from '../styles'

interface QuickActionsSectionProps {
  onUploadData: () => void
  onCreateModel: () => void
  onGoToLabeling: () => void
  disableCreateModel?: boolean
  disableLabeling?: boolean
  createModelHint?: string
  labelingHint?: string
  onGoToDeployment?: () => void
  disableDeployment?: boolean
  deploymentHint?: string
}

const QuickActionsSection: React.FC<QuickActionsSectionProps> = ({
  onUploadData,
  onCreateModel,
  onGoToLabeling,
  disableCreateModel = false,
  disableLabeling = false,
  createModelHint,
  labelingHint,
  onGoToDeployment,
  disableDeployment = false,
  deploymentHint,
}) => {
  return (
    <div>
      <SectionTitle>Quick Actions</SectionTitle>
      <DetailCard>
        <DetailHeader>
          <h3>Get Started</h3>
        </DetailHeader>
        <div className="p-3">
          <Row className="g-3">
            <Col md={3} sm={12}>
              <ActionsSection>
                <ActionButton $variant="primary" onClick={onUploadData}>
                  <FaUpload /> Upload Data
                </ActionButton>
              </ActionsSection>
            </Col>
            <Col md={3} sm={12}>
              <ActionsSection>
                <ActionButton
                  $variant="success"
                  onClick={onCreateModel}
                  disabled={disableCreateModel}
                  title={createModelHint}
                  aria-disabled={disableCreateModel}
                >
                  <FaBrain /> Create Model
                </ActionButton>
              </ActionsSection>
            </Col>
            <Col md={3} sm={12}>
              <ActionsSection>
                <ActionButton
                  $variant="warning"
                  onClick={onGoToLabeling}
                  disabled={disableLabeling}
                  title={labelingHint}
                  aria-disabled={disableLabeling}
                >
                  <FaPencilAlt /> Label Data
                </ActionButton>
              </ActionsSection>
            </Col>
            <Col md={3} sm={12}>
              <ActionsSection>
                <ActionButton
                  $variant="selected"
                  onClick={onGoToDeployment}
                  disabled={disableDeployment}
                  title={deploymentHint}
                  aria-disabled={disableDeployment}
                >
                  <FaRocket /> Deploy Model
                </ActionButton>
              </ActionsSection>
            </Col>
          </Row>
        </div>
      </DetailCard>
    </div>
  )
}

export default QuickActionsSection
